import { render, staticRenderFns } from "./promotion-list.vue?vue&type=template&id=1dbc98d0&scoped=true"
import script from "./promotion-list.vue?vue&type=script&lang=js"
export * from "./promotion-list.vue?vue&type=script&lang=js"
import style0 from "./promotion-list.vue?vue&type=style&index=0&id=1dbc98d0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc98d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbc98d0')) {
      api.createRecord('1dbc98d0', component.options)
    } else {
      api.reload('1dbc98d0', component.options)
    }
    module.hot.accept("./promotion-list.vue?vue&type=template&id=1dbc98d0&scoped=true", function () {
      api.rerender('1dbc98d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/seedFarm-management/promotion-list/promotion-list.vue"
export default component.exports